import { render, staticRenderFns } from "./SuperScoreProgressWidget.vue?vue&type=template&id=0c390fb8&scoped=true"
import script from "./SuperScoreProgressWidget.vue?vue&type=script&lang=ts"
export * from "./SuperScoreProgressWidget.vue?vue&type=script&lang=ts"
import style0 from "./SuperScoreProgressWidget.vue?vue&type=style&index=0&id=0c390fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c390fb8",
  null
  
)

export default component.exports